import React from "react";
import { object } from "prop-types";
import { ThreeColTwelveStories } from "../../../../arrow";
import "./styles.m.css";

export const ArrowThreeColTwelveStories = ({ collection }) => {
  const config = {
    buttonText: `Read More`,
    showImagePlaceholder: true,
    showSection: false,
    theme: "",
    showReadTime: false,
  };
  return (
    <div styleName="wrapper">
      <ThreeColTwelveStories collection={collection} config={config} />
    </div>
  );
};

ArrowThreeColTwelveStories.propTypes = {
  collection: object,
};

ArrowThreeColTwelveStories.storyLimit = 6;
